import React, { useContext, useEffect, useRef, useState } from "react";
import ALoader from "views/pages/manage/common/a-loader";
import styles from "./styles.module.scss";
import { ReactComponent as BackIcon } from "assets/img/svg/BackButton.svg";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { useHistory } from "react-router";
import {
  successToast,
  failureToast,
} from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import ListComponent from "./ListComponent";
import {
  getCreateReqBody,
  getDropdownData,
  getSubSubCategory,
  getSubSubCategoryList,
  getAcdCarrierList,
} from "./constant";
import { checkPermission } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { RolePermissions, PermissionContext } from "appContext";
import { getClassificationData } from "views/pages/manage/unAssigned/studentCharges/studentChargesDetails";
import { pages } from "views/pages/manage/common/constant";
import {
  fetchConcessionList,
  createConcession,
  updateConcession,
  toggleConcessionStatus,
} from "./api";

const ConcessionReversalMaster = () => {
  const [loader, setLoader] = useState(false);
  const [allConcessionCategories, setAllConcessionCategories] = useState([]);
  const [dropdownData, setDropdownData] = useState();
  const [rows, setRows] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [isNew, setIsNew] = useState(false);
  const history = useHistory();
  const listRef = useRef();
  const userPermissions = RolePermissions(
    useContext(PermissionContext),
    pages["concessionReversalMaster"]["id"]
  );

  const loadDropdownData = async () => {
    setLoader(true);
    const data = await getDropdownData();
    setDropdownData(data);
    setLoader(false);
  };

  const loadConcessionList = async (page = 0) => {
    setLoader(true);
    const subCategoryList = getSubSubCategoryList(allConcessionCategories);
    const academicCarrier = dropdownData?.academicCareer;
    try {
      const response = await fetchConcessionList();
      if (response?.code === 200) {
        const updateResponse = response?.data?.map((item) => {
          return {
            ...item,
            concessionCategory: getSubSubCategory(
              subCategoryList,
              item?.subSubCategoryId
            ),
            academicCareer: getAcdCarrierList(
              academicCarrier,
              item?.academicCareerIds
            ),
            dateControl: { value: item?.dateControl, label: item?.dateControl },
          };
        });
        setRows(updateResponse);
        listRef.current.stopEditing();
      } else {
        setRows([]);
      }
    } catch (error) {
      failureToast("Failed to fetch list");
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const handleCreate = async (rowData, selectedConcessionCategory) => {
    setLoader(true);
    const reqBody = getCreateReqBody(rowData, selectedConcessionCategory);
    try {
      const res = await createConcession(reqBody);
      if (res?.code === 200) {
        successToast(res?.message);
        loadConcessionList(0);
      }
    } catch (error) {
      failureToast("Creation failed");
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const handleUpdate = async (rowData, selectedConcessionCategory) => {
    setLoader(true);
    const reqBody = getCreateReqBody(rowData, selectedConcessionCategory);
    try {
      const res = await updateConcession(rowData?.id, reqBody);
      if (res?.code === 200) {
        successToast(res?.message);
        loadConcessionList(currentPage);
      } else {
        failureToast(res?.message);
      }
    } catch (error) {
      failureToast("Update failed");
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const handleToggleStatus = async (rowData) => {
    setLoader(true);
    const reqBody = {
      ...getCreateReqBody(rowData),
      status: rowData?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
    };
    try {
      const res = await toggleConcessionStatus(rowData?.id, reqBody);
      if (res?.code === 200) {
        successToast(res?.message);
        loadConcessionList(currentPage);
      } else {
        failureToast(res?.message);
      }
    } catch (error) {
      failureToast("Status update failed");
      console.error(error);
    }
    setLoader(false);
  };

  useEffect(() => {
    loadDropdownData();
    getClassificationData(setAllConcessionCategories);
  }, []);

  useEffect(() => {
    if (
      dropdownData?.academicCareer.length &&
      allConcessionCategories.length > 0
    ) {
      loadConcessionList(0);
    }
  }, [dropdownData, allConcessionCategories]);

  return (
    <div className={`remove-container-top-space`}>
      {loader && <ALoader position="fixed" />}
      <div className={`${styles["page-container"]}`}>
        <div className="d-flex justify-content-between align-items-start">
          <div className={`${styles["header-bar"]}`}>
            <BackIcon onClick={() => history.goBack()} />
            <div className="ml-3 bold-heading-label color-dark">
              Concession reversal setup
            </div>
          </div>
          {checkPermission(userPermissions, "C") && (
            <AButton
              onClick={() => listRef?.current?.addNewRow()}
              variant="primary_filled"
            >
              + Add configuration
            </AButton>
          )}
        </div>
        <ListComponent
          ref={listRef}
          rows={rows}
          loader={loader}
          dropdown={dropdownData}
          createHandler={handleCreate}
          updateHandler={handleUpdate}
          toggleStatusHandler={handleToggleStatus}
          currentPage={currentPage}
          setIsNew={setIsNew}
          isNew={isNew}
          userPermissions={userPermissions}
          allConcessionCategories={allConcessionCategories}
        />
      </div>
    </div>
  );
};

export default ConcessionReversalMaster;
